import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";
import {ACTIVITY_LEVEL} from "../../../../const/WeightLossQuestionnaire";

export const ActivityLevel = (props) => {
  const data = {
    title: "What's your activity level?",
    list: ACTIVITY_LEVEL
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
